<template>
  <div class="total-resume">
    <div v-if="totalPurshaseProduct > 0">
      <div class="row count-line">
        <div class="col-7">
          <b>{{ totalPurshaseProduct }} Inscrições </b>
        </div>
        <div class="col-5 tr">
          <span
            ><b><price :price="total"></price></b>
          </span>
        </div>
      </div>

      <div class="green row count-line" v-for="discount in getDiscounts">
        <div class="col-7">
          {{ discount.name }}
        </div>
        <div class="col-5 tr">
          <span
            ><b> – <price :price="discount.discountValue"> </price> </b
          ></span>
        </div>
      </div>

      <div class="row count-line" v-for="memberProducts in getMemberProducts">
        <div class="col-7">
          {{ memberProducts.name }}
        </div>
        <div class="col-5 tr">
          <span
            ><b> + <price :price="memberProducts.price"> </price> </b
          ></span>
        </div>
      </div>



      <div class="green row count-line" v-if="getCupom">
        <div class="col-7">
            <div> CUPOM   </div>
            <div><small><b>{{ getCupom.code }} </b> <small @click="$store.commit('OrderStore/setState',{cupom:null})" style="color:#aaaaaa;font-size:10px"><icon icon="trash" /></small> </small></div>
        </div>
        <div class="col-5 tr">
          <span>
              <b> - 
                <span v-if="getCupom.isPercent">   <span class='price'> {{parseInt(getCupom.discount,10)}}% </span> </span>
                <span v-else> <price :price="getCupom.discount"> </price> </span>
             </b>
            </span>
        </div>
      </div>

      <!-- <hr/> -->
      <div class="row mt-3">
        <div class="col-12 tr">
          Total:
          <span class="f3"
            ><b><price :price="totalFinal"></price></b>
          </span>
        </div>
      </div>
    
        <div class='cupom mt-3' v-if="!getCupom && canShowCupom">
            <div class='pointer' @click="showCupom = !showCupom"><small style="font-size:14px; color:#007bff">Possui cupom de desconto?</small></div>
            <div v-if="showCupom" class='mt-2' >
                <div class="row">
                    <div class="col-12 col-sm-8">
                        <input v-model="cupomCode" type="text" placeholder="Digite o codigo"/> 
                    </div>
                    <div class="col-12 col-sm-4">
                        <button @click="validarCupom" class='btn btn-primary'>Validar</button>
                    </div>
                </div>
                <div class="msg">
                    <div v-if="cupomError && getCupomErroMessage" class="" style="color:red;font-size:12px"> {{ getCupomErroMessage }}</div>
                    <div v-if="cupomError && !getCupomErroMessage" class="" style="color:red;font-size:12px"> Cupom Inválido</div>
                </div>
            </div>
        </div>
    </div>

    <div v-else class="tc gray o-50">
      -- Selecione ver o total --
    </div>
  </div>
</template>

<script>
export default {
  props:{
    canShowCupom:false
  },

  data:function(){
      return { showCupom:false, cupomCode:'',cupomError:false }
  },
  computed: {
    totalPurshaseProduct: function() {
      return this.$store.getters["OrderStore/purshaseProductsForCurrentOrder"]
        .length;
    },
    total: function() {
      return this.$store.getters["OrderStore/getTotal"];
    },
    totalFinal: function() {
      return this.$store.getters["OrderStore/getTotalFinal"];
    },
    getMemberProducts: function() {
      return this.$store.getters["OrderStore/getMemberProducts"];
    },
    getDiscounts: function() {
      return this.$store.getters["OrderStore/getDiscounts"];
    },
    getCupom: function() {
      return this.$store.getters["OrderStore/cupom"];
    },
    getCupomErroMessage: function() {
      return this.$store.getters["OrderStore/cupomErroMessage"];
    }
  },
  watch:{
    getCupom:function(val,oldVal){
      if(val == null && oldVal != null){
        this.cupomError = false
        this.showCupom = false
        this.cupomCode = ''
      }
    },
      cupomCode:function(){
          this.cupomError = false
      },
      canShowCupom:function(val,oldVal){
        if(val ==  true && oldVal == false){
            this.cupomError = false
            this.showCupom = false
            this.cupomCode = ''
            this.$store.dispatch('OrderStore/clearCupom')
        }
      }
  },

  methods:{
      validarCupom:async function(){
          //cupom especial para caixa só é valido por cartao caixa
          if(this.cupomCode.toUpperCase() == 'CLIENTE_CAIXA'){
            this.cupomError = true
            return;
          }
          var res = await this.$store.dispatch('OrderStore/checkCupom',this.cupomCode)
          if(res===false){
              this.cupomError = true
          }else{
              this.cupomError = false
              this.showCupom = false
              this.cupomCode = ''
          }

      }
  }
};
</script>

<style lang="stylus">

.total-resume{

    background:white;
    padding:1em;
    .count-line{
        padding: 0.5em 0.2em;
        border-bottom: 1px dotted rgba(0,0,0,0.1)
    }
}
.cupom{
    .col-12{
        
        padding-right:5px;
        
    }
    input{
        display:block
        width: 100%;
        text-align:left;
    }
    button{
        font-size:11px
        width: 100%
    }
}
</style>
